import { useState } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "src/@/components/ui/dialog";
import { Input } from "src/@/components/ui/input";
import { Label } from "src/@/components/ui/label";
import v2_actionCriarAutomacao from "src/actions/v2/automacoes/v2_actionCriarAutomacao";
import { AUTOMACOES_DESIGN as D } from "src/pages/dashboard/Automacoes/Automacoes.design";

export default function DialogCriarAutomacao({ user, onCallback }) {
    const { t } = useTranslation("automation");
    const [automationName, setAutomationName] = useState("");
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const handleCreate = async () => {
        let data = {
            scope: {
                name: automationName,
                userId: user.id,
            },
        };
        try {
            const response = await v2_actionCriarAutomacao(user.clienteId, data);
            setAutomationName("");
            setOpen(false);
            onCallback(response.data.data);
            navigate(`/dashboard/automacoes/workflow/${response.data.data._id}`);
        } catch (error) {
            console.error(error);
        }
        setAutomationName("");
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <button type="button" className={D.primaryButton}>
                    {t("createDialog.trigger", "Criar nova automação")}
                </button>
            </DialogTrigger>

            <DialogContent className="bg-white border border-[#e7e7ec] rounded-[12px]">
                <DialogHeader>
                    <DialogTitle className={D.dialogTitle}>
                        {t("createDialog.title", "Nova Automação")}
                    </DialogTitle>
                    <DialogDescription className={D.dialogDesc}>
                        {t(
                            "createDialog.description",
                            'Preencha o nome da automação abaixo e clique em "Criar" para continuar'
                        )}
                    </DialogDescription>
                </DialogHeader>

                <div className={D.field}>
                    <Label htmlFor="automation-name" className={D.label}>
                        {t("labels.name", "Nome", { ns: "common" })}
                    </Label>
                    <Input
                        id="automation-name"
                        type="text"
                        maxLength={70}
                        placeholder={t("createDialog.namePlaceholder", "Digite o nome da automação")}
                        value={automationName}
                        onChange={(e) => setAutomationName(e.target.value)}
                        className={D.input}
                    />
                    <p className={D.hint}>
                        {t(
                            "createDialog.nameHint",
                            "Escolha um nome claro, como “Boas-vindas no WhatsApp” ou “Lead novo no funil”."
                        )}
                    </p>
                </div>

                <DialogFooter className={D.dialogFooter}>
                    <button
                        type="button"
                        onClick={() => {
                            setAutomationName("");
                            setOpen(false);
                        }}
                        className={D.ghostButton}
                    >
                        {t("buttons.cancel", "Cancelar", { ns: "common" })}
                    </button>
                    <button
                        type="button"
                        disabled={!automationName}
                        onClick={handleCreate}
                        className={D.primaryButton}
                    >
                        {t("buttons.continue", "Continuar", { ns: "common" })}
                    </button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
